<div *ngIf="!init" style="align-self: center;">
  <mat-spinner
    style="margin: auto;"
    color="primary"
    diameter="48"
  ></mat-spinner>
</div>
<div class="edit-project" *ngIf="init">
  <div class="actions-button">
    <button
      class="menu-button"
      (click)="openActions()"
      type="button"
      mat-button
    >
      Acties
    </button>
    <button
      class="menu-button"
      (click)="openNotificationMailModal()"
      type="button"
      mat-button
    >
      Mail
    </button>
    <button
      *ngIf="!generatingPlacementSticker"
      class="menu-button"
      (click)="generatePlacementSticker()"
      type="button"
      mat-button
    >
      Plakbrief
    </button>
    <div *ngIf="generatingPlacementSticker" style="align-self: center;">
      <mat-spinner color="primary" diameter="24"></mat-spinner>
    </div>
  </div>
  <!-- BEDRIJF sectie-->
  <div class="underline upper-space" #companySection>
    <div class="container">
      <div
        [class.collapsed]="isCollapsedCompany"
        class="fixed-section-header-height d-flex clickable"
        (click)="expandCompany(!isCollapsedCompany)"
        [attr.aria-expanded]="!isCollapsedCompany"
      >
        <h2>
          Bedrijf
          <span class="black" *ngIf="involvedCompanyNames?.length > 0">
            - {{ involvedCompanyNames }}
          </span>
        </h2>
        <div
          class="small-left-space"
          *ngIf="project.collaborative"
          [matTooltip]="'Gezamenlijk project'"
        >
          <mat-icon class="scale-collaborative-icon">groups</mat-icon>
        </div>
        <div class="flexer d-flex requestor-space" *ngIf="model.projectUser">
          <div
            class="placers-space project-user-initials rounded-circle in-the-middle requestor-translate"
            [matTooltip]="
              model.projectUser.firstName
                | personName: model.projectUser.lastName
            "
          >
            <span
              *ngIf="!model.projectUser?.profilePicture"
              class="initials-font-size"
            >
              {{
                model.projectUser.firstName
                  | initials: model.projectUser.lastName
              }}
            </span>
            <span *ngIf="model.projectUser?.profilePicture">
              <img
                class="rounded-circle"
                width="30px"
                height="30px"
                [src]="
                  '/api/assets/' + model.projectUser.profilePicture.uuid + '/30'
                "
              />
            </span>
          </div>
        </div>
        <button class="edit-button btn btn-sm pull-right" mat-icon-button>
          <mat-icon svgIcon="edit"></mat-icon>
        </button>
        <button mat-icon-button class="arrow-button">
          <mat-icon svgIcon="arrow-up"></mat-icon>
        </button>
      </div>

      <div
        id="collapseCompany"
        [collapse]="isCollapsedCompany"
        [isAnimated]="!safari"
        (expanded)="scrollTo(companySection)"
      >
        <contact-picker
          [inputProject]="project"
          [invoiceSent]="invoiceSent"
          [projectContactIdAssigned]="projectContactIdAssigned"
          (projectContactChange)="saveContacts($event)"
          (next)="nextPart()"
        ></contact-picker>
      </div>
    </div>
  </div>

  <!-- PROJECT sectie-->
  <div class="underline upper-space" *ngIf="!isHiddenProject" #projectSection>
    <div class="container">
      <div
        [class.collapsed]="isCollapsedProject"
        class="section-header d-flex clickable"
        (click)="expandProject(!isCollapsedProject)"
        [attr.aria-expanded]="!isCollapsedProject"
      >
        <h2 class="flexer d-flex fixed-section-header-height">
          Project {{ project.id != null ? ' #' + project.id : '' }}
          <div class="smaller-placers-space d-flex request-translate">
            <span class="black" *ngIf="model.currentCreatedAt != null">
              - aanvraag ({{
                model.currentCreatedAt | date: 'dd/MM/yyyy'
              }})</span
            >
            <ng-container
              *ngTemplateOutlet="
                userDisplay;
                context: {
                  employee: firstDesigner
                }
              "
            ></ng-container>
          </div>
        </h2>
        <button class="edit-button btn btn-sm pull-right" mat-icon-button>
          <mat-icon svgIcon="edit"></mat-icon>
        </button>
        <button mat-icon-button class="arrow-button">
          <mat-icon svgIcon="arrow-up"></mat-icon>
        </button>
      </div>

      <div
        id="collapseProject fullLength"
        [collapse]="isCollapsedProject"
        [isAnimated]="!safari"
        (expanded)="scrollTo(projectSection)"
      >
        <div class="">
          <product-picker
            *ngFor="let product of this.project.products; let index = index"
            [inputProject]="this.project"
            [inputProduct]="product"
            [index]="index"
            [involvedCompanies]="involvedCompanies"
            [pmsColorAdded]="pmsColorAdded"
            [standardStickerPartDeleted]="standardStickerPartDeleted"
            [isCollapsed]="isCollapsedProject"
            (updateProject)="this.saveSubProject()"
            (typeWasSelected)="productTypeWasSelected()"
          >
          </product-picker>

          <mat-card
            *ngIf="showAddProduct"
            class="mat-elevation-z0 clickable overflow-hidden vertically-center"
            (click)="addProduct()"
          >
            <mat-icon
              class="plus-sign vertically-center"
              svgIcon="add"
            ></mat-icon>
            <span class="vertically-center">Onderdeel toevoegen</span>
          </mat-card>
        </div>

        <div class="flexer text-right">
          <button
            class="button"
            (click)="projectsSet($event)"
            type="button"
            mat-button
          >
            Volgende
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- PLAATSING -->
  <div class="underline upper-space" *ngIf="!isHiddenProject" #placementSection>
    <div class="container">
      <div
        [class.collapsed]="isCollapsedPlacement"
        class="section-header d-flex clickable"
        (click)="expandPlacement(!isCollapsedPlacement)"
        [attr.aria-expanded]="!isCollapsedPlacement"
      >
        <div [ngClass]="placers.length === 0 ? 'flexer' : ''">
          <placement-header [products]="project.products"></placement-header>
        </div>
        <div
          [ngClass]="placers.length > 0 ? 'flexer' : ''"
          class="d-flex placers-space"
          *ngIf="model.withPlacement"
        >
          <div
            *ngFor="let placer of placers"
            class="employee-initials rounded-circle in-the-middle placer-margin"
            [matTooltip]="
              placer.user?.firstName | initials: placer.user?.lastName
            "
          >
            <span *ngIf="!placer.user?.profilePicture">
              {{ placer.user.firstName | initials: placer.user.lastName }}
            </span>
            <span *ngIf="placer.user?.profilePicture">
              <img
                class="rounded-circle"
                width="30px"
                height="30px"
                [src]="'/api/assets/' + placer.user.profilePicture.uuid + '/30'"
              />
            </span>
          </div>
        </div>
        <button class="edit-button btn btn-sm pull-right" mat-icon-button>
          <mat-icon svgIcon="edit"></mat-icon>
        </button>
        <button mat-icon-button class="arrow-button">
          <mat-icon svgIcon="arrow-up"></mat-icon>
        </button>
      </div>

      <div
        id="collapsePlacement"
        [collapse]="isCollapsedPlacement"
        [isAnimated]="!safari"
        (expanded)="scrollTo(placementSection)"
      >
        <div>
          <div class="upper-space">
            <mat-radio-group class="inline upper-space">
              <mat-radio-button
                class="right-space"
                [checked]="model.withPlacement"
                (change)="setWithPlacement($event.value)"
                [value]="true"
                >Met Plaatsing
              </mat-radio-button>
              <mat-radio-button
                class="left-space"
                [checked]="!model.withPlacement"
                (change)="setWithPlacement($event.value)"
                [value]="false"
                >Zonder Plaatsing
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="upper-space" *ngIf="model.withPlacement">
          <placement-picker
            [inputProject]="this.project"
            [inputSubProject]="this.model"
            [inputProjectPlacement]="model.projectPlacement"
            [isCollapsed]="isCollapsedPlacement"
            (outputProject)="this.saveSubProject()"
          >
          </placement-picker>
        </div>

        <div class="upper-space" *ngIf="!model.withPlacement">
          <textarea-input
            [placeholder]="
              'Gelieve hier meer info over de afhaling in te geven'
            "
            [initContent]="model.pickup.extraInfoPickup"
            [title]="'Afhaling'"
            (answer)="setPickupInfo($event)"
          ></textarea-input>
          <mat-card
            *ngIf="model.withPlacement === false && model.pickup != null"
            class="internal-form mat-elevation-z0 card-bottom-space"
          >
            <checkbox
              [text]="'Klaar voor afhaling'"
              [checked]="model.pickup.ready"
              (answer)="setPickupReady($event)"
            ></checkbox>
          </mat-card>
        </div>
        <div class="flexer text-right">
          <button
            class="button"
            type="button"
            mat-button
            (click)="placementsSet($event)"
          >
            Volgende
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- OVERZICHT-->
  <div class="underline upper-space" *ngIf="!isHiddenProject" #overviewSection>
    <div class="container">
      <div
        [class.collapsed]="isCollapsedOverview"
        class="section-header d-flex clickable"
        (click)="expandOverview(!isCollapsedOverview)"
        [attr.aria-expanded]="!isCollapsedOverview"
      >
        <h2 class="flexer">
          Overzicht<span class="black">{{ invoiceSentDateString }}</span>
        </h2>
        <button class="edit-button btn btn-sm pull-right" mat-icon-button>
          <mat-icon svgIcon="edit"></mat-icon>
        </button>
        <button mat-icon-button class="arrow-button">
          <mat-icon svgIcon="arrow-up"></mat-icon>
        </button>
      </div>

      <div
        id="collapseOverview"
        [collapse]="isCollapsedOverview"
        [isAnimated]="!safari"
        (expanded)="scrollTo(overviewSection)"
      >
        <div class="upper-space">
          <project-summary
            [project]="project"
            [inputProject]="this.model"
            [involvedCompanies]="involvedCompanies"
            [invoiceSent]="invoiceSent"
            [productAdded]="productAdded"
            [boardPartAdded]="boardPartAdded"
            [standardStickerPartAdded]="standardStickerPartAdded"
            [standardStickerPartDeleted]="standardStickerPartDeleted"
            (outputProject)="this.saveSubProject()"
          ></project-summary>
        </div>
      </div>
    </div>
  </div>
</div>
<br />
<ng-template #userDisplay let-employee="employee">
  <div class="d-flex requestor-space" *ngIf="employee && employee.user">
    <div
      class="placers-space employee-initials rounded-circle in-the-middle requestor-translate"
      [matTooltip]="
        employee.user.firstName | personName: employee.user.lastName
      "
    >
      <span *ngIf="!employee.user.profilePicture" class="initials-font-size">
        {{ employee.user.firstName | initials: employee.user.lastName }}
      </span>
      <span *ngIf="employee.user.profilePicture">
        <img
          class="rounded-circle"
          width="30px"
          height="30px"
          [src]="'/api/assets/' + employee.user.profilePicture.uuid + '/30'"
        />
      </span>
    </div>
  </div>
  <div class="d-flex requestor-space" *ngIf="!(employee && employee.user)">
    <div
      class="placers-space empty-employee-initials rounded-circle in-the-middle requestor-translate"
    ></div>
  </div>
</ng-template>
